"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArrowIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 12 7"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M25.707 17.273a.983.983 0 01.011 1.39l-4.97 5.053a.948.948 0 01-.746.281.95.95 0 01-.74-.27l-.01-.011-4.97-5.054a.983.983 0 010-1.378.95.95 0 011.355 0L20 21.72l4.363-4.436a.95.95 0 011.344-.011z",
  transform: "translate(-14 -17)"
}));

var _default = ArrowIcon;
exports.default = _default;